import { Injectable } from '@angular/core';
import * as Auth from 'aws-amplify/auth';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // Define the API endpoint using the environment configuration
  private _apiEndpoint: string = `https://${environment.api.host}`;

  constructor(
    private http: HttpClient
  ) { }

  private async getJwtToken(): Promise<string | null> {
    try {
      const session = await Auth.fetchAuthSession();
      if (session.tokens?.idToken) {
        return session.tokens.idToken.toString();
      }
      return null;
    } catch (error) {
      console.error('Error fetching JWT token:', error);
      return null;
    }
  }
  
  async getAuthToken({
    client_id,
    redirect_uri,
    state,
    response_type
  }: {
    client_id: string,
    redirect_uri: string,
    state: string,
    response_type: string
  }): Promise<any> {

    try {

      const request = this.http.get(`${this._apiEndpoint}/auth`, {
        headers: {
          'Authorization': `Bearer ${await this.getJwtToken()}`
        },
        params: {
          client_id,
          redirect_uri,
          state,
          response_type
        }
      }).pipe(take(1));

      const response = await lastValueFrom(request);
      return response;

    } catch (error) {
      console.error('Error fetching auth token:', error);
      return null;
    }
  }

}
